import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Input, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, CardTitle, FormGroup, Label, Form } from "reactstrap";
import { Link, Redirect, withRouter } from "react-router-dom";
import {Table, Thead, Tbody, Tr, Th, Td} from 'react-super-responsive-table';

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

import { connect } from 'react-redux';


import { getDashboardData } from '../../store/actions';
import Select from "react-select";
//i18n
import { withNamespaces } from 'react-i18next';
import moment from "moment";
import DashboardMap from './maps';
import { getPlayer } from '../../store/actions';
import { noParamPost } from '../../apiHelpers/commonApiHelper';




const Dashboard = (props) => {


    useEffect(() => {
        props.getPlayer();
        noParamPost('/api/v1/players/backup_log')
            .then(res => console.log(res))
            .catch(err => console.log(err))
    }, [])

    useEffect(() => {
        if(props.screens && props.screens.length > 0) {
            const total = props.screens.length;
            let onlineCount = 0;
            let syncCount = 0;
            props.screens.forEach((item) => {
                if(item.is_online) {
                    onlineCount ++;
                }
                if(!item.is_sync) {
                    syncCount ++;
                }
            });
            setOnlineCount(onlineCount);
            setOffLineCount(total - onlineCount);
            setSyncCount(syncCount);
            setTotal(total);

        }
    }, [props.screens])

    const [offlineCount, setOffLineCount] = useState(0);
    const [onLineCount, setOnlineCount] = useState(0);
    const [syncCount, setSyncCount] = useState(0);
    const [total, setTotal] = useState(1);


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col xs={12} md={6} lg={3} className="mb-3">
                            <div className="online-div">
                                <div>
                                    <h5>Online Screens <span className="percent">{!props.loading ? (onLineCount / total).toFixed(2) * 100 : <i className="fas fa-circle-notch fa-spin"></i>}%</span></h5>
                                    <h1>{!props.loading ? onLineCount : <i className="fas fa-circle-notch fa-spin"></i>}</h1>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={3} className="mb-3">
                            <div className="offline-div">
                                <div>
                                    <h5>Offline <span className="percent">{!props.loading ? (offlineCount / total).toFixed(2) * 100 : <i className="fas fa-circle-notch fa-spin"></i>}%</span></h5>
                                    <h1>{!props.loading ? offlineCount : <i className="fas fa-circle-notch fa-spin"></i>}</h1>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={3} className="mb-3">
                            <div className="outsync-div">
                                <div>
                                    <h5>Out Off Sync<span className="percent">{!props.loading ? (syncCount / total).toFixed(2) * 100 : <i className="fas fa-circle-notch fa-spin"></i>}%</span></h5>
                                    <h1>{!props.loading ? syncCount : <i className="fas fa-circle-notch fa-spin"></i>}</h1>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={3} className="mb-3">
                            <div className="disabled-div">
                                <div>
                                    <h5>Disabled<span className="percent">{!props.loading && props.disabled_count ? (props.disabled_count / total).toFixed(2) * 100 : <i className="fas fa-circle-notch fa-spin"></i> }%</span></h5>
                                    <h1>{!props.loading && props.disabled_count ? props.disabled_count : <i className="fas fa-circle-notch fa-spin"></i>}</h1>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <DashboardMap marker={props.screens ? props.screens : []} />
                </Container>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    const { screens, loading, disabled_count } = state.ScreenReducer;
    return { screens, loading, disabled_count };
}

export default withRouter(connect(mapStateToProps, { getPlayer })(withNamespaces()(Dashboard)));
